/**
 * Reference-counted body overflow lock.
 * Multiple modals can independently lock/unlock scroll without conflicting.
 */
let lockCount = 0;

export function lockBodyScroll() {
  lockCount++;
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden';
  }
}

export function unlockBodyScroll() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = '';
  }
}
